import React from 'react';
import { Helmet } from 'react-helmet';
import './pap.css';

const Pap = () => {
  return (
    <div className="pap-container">
      <Helmet>
        <title>Покупка и оплата | Nicotine Club</title>
        <meta 
          name="description" 
          content="Как оформить заказ на сайте Nicotine Club: выберите товар, оформите заказ, свяжитесь с менеджером и оплатите заказ. Узнайте о способах оплаты, условиях доставки и покупке сигарет с доставкой." 
        />
        <meta 
          name="keywords" 
          content="оплата Nicotine Club, способы оплаты, доставка Nicotine Club, как купить сигареты, условия доставки, оплата онлайн, купить сигареты с доставкой, доставка табачных изделий" 
        />
      </Helmet>
      <h1 className="pap-title">Покупка и оплата</h1>

      {/* Раздел 1: Как оформить заказ */}
      <div className="pap-section">
        <h2 className="pap-subtitle">Как оформить заказ на сайте</h2>
        <p className="pap-description">
          Выберите товар из нашего широкого ассортимента – сигареты, табачные изделия или аксессуары. Добавьте понравившиеся товары в корзину и перейдите к оформлению заказа.
        </p>
      </div>

      {/* Раздел 2: Оформление заказа */}
      <div className="pap-section">
        <h2 className="pap-subtitle">Оформление заказа</h2>
        <p className="pap-description">
          Перейдите в корзину и заполните форму заказа, указав ваши контактные данные, адрес доставки и предпочтительный способ оплаты. Если у вас возникли вопросы в процессе оформления, воспользуйтесь онлайн-чатом в правом нижнем углу – наши операторы помогут с выбором товара или оформлением заказа.
        </p>
      </div>

      {/* Раздел 3: Способы оплаты */}
      <div className="pap-section">
        <h2 className="pap-subtitle">Способы оплаты</h2>
        <p className="pap-description">
          Мы предлагаем несколько удобных способов оплаты:
          <br /><br />
          <strong>Оплата на сайте:</strong> Банковской картой (Visa, MasterCard, Мир) или электронными кошельками (Qiwi, WebMoney, Яндекс.Деньги).
          <br /><br />
          <strong>Оплата через менеджера:</strong> После оформления заказа вы можете оплатить его через персонального менеджера, который предоставит вам реквизиты для оплаты и ответит на все вопросы.
          <br /><br />
          <strong>Наличными при получении:</strong> При выборе курьерской доставки вы можете оплатить заказ наличными.
        </p>
      </div>
    </div>
  );
};

export default Pap;
